/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as angular from 'angular';

//todo: add a watch function to the user generation/ project generation stuff that allows the generated
//array to be updated when new entires are added

angular.module('ticketspaceApp').factory('firebaseUsers', [
	'$q',
	'firebaseUsersGetters',
	function ($q, firebaseUsersGetters) {
		return {
			getUsers: firebaseUsersGetters.getUsers,
			getUsersSync: firebaseUsersGetters.getUsersSync,
			userFromUserId: firebaseUsersGetters.userFromUserId,
		};
	},
]);
